<template>
    <md-toolbar md-elevation="0" class="md-transparent">
        <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
                <h3 class="md-title">{{ $route.name }}</h3>
            </div>
            <div class="md-toolbar-section-end">
                <md-button
                    class="md-just-icon md-simple md-toolbar-toggle"
                    :class="{ toggled: $sidebar.showSidebar }"
                    @click="toggleSidebar"
                    >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </md-button>

                <div class="md-collapse">
                    <md-list>
                        <md-list-item to="user">
                            <p class="md-title">{{ user.lastname + " " + user.firstname }}</p>
                            <i class="material-icons">person</i>
                            <p class="hidden-lg hidden-md">Profile</p>
                        </md-list-item>
                    </md-list>
                </div>
            </div>
        </div>
    </md-toolbar>
</template>

<script>
import store from "@/store";

export default {
    data() {
        return {
            selectedEmployee: null,
            employees: [
                "Jim Halpert",
                "Dwight Schrute",
                "Michael Scott",
                "Pam Beesly",
                "Angela Martin",
                "Kelly Kapoor",
                "Ryan Howard",
                "Kevin Malone"
            ]
        };
    },
    methods: {
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        }
    },
    computed: {
        user() {
            return store.getters.user;
        }
    }
};
</script>

<style lang="css"></style>
